import React, { ReactNode, createContext, useContext, useMemo } from "react";
import HomaticApiClient from "../api/HomaticApiClient";

const ApiContext = createContext<HomaticApiClient | null>(null);

export default function ApiProvider({ children } : { children: ReactNode }) {
  const api = useMemo(() => new HomaticApiClient(), []);
  return (
    <ApiContext.Provider value={api}>
      {children}
    </ApiContext.Provider>
  );
}

export function useApi() {
  return useContext(ApiContext) as HomaticApiClient;
}
